export default __webpack_public_path__ + "static/media/kitchen5-afterE-1920w.96429a9b.avif";